import { AUTH_LOGIN, AUTH_LOGOUT } from "../actions/authActions";

const initialState = {
  user: {},
  loggedIn: false,
  token: ''
}

function authReducer(state = initialState, action) {
  switch (action.type) {
  case AUTH_LOGIN:
    return {
      ...state,
      loggedIn: true,
      token: action.payload.token,
      user: action.payload.user,
    }
  case AUTH_LOGOUT:
    return {
      loggedIn: false,
      token: '',
      user: {},
    }
  default:
    return state;
  }
}

export default authReducer;